export default "__VITE_ASSET__BNeuC_bN__"